// OK

import apiClient from "../plugins/axios-instance";
import Properties from "../properties";

const API_URL = "https://karyawan." + Properties.DOMAIN_URL + "/api/v1";

export default class KaryawanAPIService {
  constructor() { }
  static getByNIK = (nik) =>
    apiClient.get(API_URL + "/karyawans/" + nik);
    
  static getByID = (id) =>
    apiClient.get(API_URL + "/member-admins/by-id/" + id);
    
  static login = (nik, body) =>
    apiClient.post(API_URL + "/karyawans/" + nik + "/auth/pin", body);

  static gantiPassword = (nik, body) =>
    apiClient.put(API_URL + "/karyawans/" + nik + "/auth/pin", body);

  static getRoleKaryawan = () =>
    apiClient.get(API_URL + "/role");
    
  static defaultPassword = (nik) =>
    apiClient.put(API_URL + "/karyawans/" + nik + "/auth/default", {});

  static resetPassword = (nik) =>
    apiClient.put(API_URL + "/karyawans/" + nik + "/auth/reset", {});
}
